export class Chart {
  labels: string[] ;
  data: object[] ;
  options: object ;
  size: number[] ;
  colors: object ;
}



// WEBPACK FOOTER //
// ./src/app/home/chart.ts